import { EUserType } from "services/BackendApi";
import { ParameterService } from 'services/ParametersProviderApi/ParametersService';

let email: string | null = null;
let country: string | null = null;
let userType: EUserType | null = null;
let travelAgentId: string | null = null;

export const setTrackingContext = (ctx: {
  email: string;
  country?: string | null;
  userType: EUserType;
  travelAgentId?: string | null;
}): void => {
  email = ctx.email || null;
  if (ctx.country !== undefined) country = ctx.country || null;
  userType = ctx.userType || null;
  if (ctx.travelAgentId !== undefined) travelAgentId = ctx.travelAgentId || null;
};

export const clearTrackingContext = (): void => {
  email = null;
  country = null;
  userType = null;
  travelAgentId = null;
};

export const getTrackingContext = (): {
  email: string | null;
  country: string | null;
  userType: EUserType | null;
  travelAgentId: string | null;
} => ({
  email,
  country,
  userType,
  travelAgentId,
});

export const hasTrackingIdentity = (): boolean => Boolean(email);

const getTrackedAdminEmails = (): string[] => {
  const aiMails = ParameterService.getParameters().AI_TRACKING_EVENTS_EMAILS;
  if (!aiMails) return [];
  return aiMails
    .split(',')
    .map(mail => mail.trim().toLowerCase())
    .filter(Boolean);
};

export const isTrackedUser = (): boolean =>
  (email !== null && getTrackedAdminEmails().includes(email.trim().toLowerCase())) ||
  (userType !== null && [EUserType.TA, EUserType.SR].includes(userType));
